"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filterCurrencies;
function filterCurrencies(affilIdRaw, allowlist, currencies) {
  const affilId = affilIdRaw.toLowerCase();
  return Object.fromEntries(Object.entries(currencies).filter(_ref => {
    let [, curr] = _ref;
    if (typeof curr.enabledOnAffilId === "string") {
      return affilId.includes(curr.enabledOnAffilId);
    }
    return curr.enabledOnAffilId.some(a => affilId.includes(a));
  }).filter(_ref2 => {
    let [, curr] = _ref2;
    return allowlist.includes(curr.id);
  }));
}